import React, { useEffect, useState } from "react";
import CondimentsList from "../../components/Condiment/CondimentList";
import { useNavigate } from "react-router-dom";
import Box from "../../UI/Box";
import Filter from "../../components/Filter/Filter";
import { SORTING_TYPE, VIEW_TYPE } from "../../entities/Filter";
import { useAppDispatch } from "../../store/store";
import { resetMixtureState } from "../../components/Mixture/MixtureSlice";
import { clearSelectedCondiments } from "../../components/Condiment/CondimentSlice";
import { resetCalculationState } from "../../components/Calculation/slice/CalculationSlice";

const TasteHarmony: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [sort, setSort] = useState<SORTING_TYPE>(SORTING_TYPE.ASC);
  const [view, setView] = useState<VIEW_TYPE>(VIEW_TYPE.GRID);
  const onHandleSelect = (condimentId: number) => {
    navigate(`/taste-harmony/${condimentId}`);
  };

  useEffect(() => {
    dispatch(clearSelectedCondiments());
    dispatch(resetCalculationState());
    dispatch(resetMixtureState());
  }, [dispatch]);

  return (
    <Box>
      <Filter sort={sort} view={view} setSort={setSort} setView={setView} />
      <CondimentsList
        sort={sort}
        view={view}
        onSelect={(condimentId) => onHandleSelect(condimentId)}
        disableSelected={true}
      />
    </Box>
  );
};

export default TasteHarmony;
